import { UserRole } from '../../models/user';

export const userRoleList = [
  {
    value: UserRole.DAILY_EMPLOYEE,
    label: 'Diarista',
  },
  {
    value: UserRole.MONTHLY_EMPLOYEE,
    label: 'Mensalista',
  },
  {
    value: UserRole.EMPLOYEE,
    label: 'Registrado',
  },
  {
    value: UserRole.CLEANING_EMPLOYEE,
    label: 'Limpeza',
  },
];

export const userRoleHumanized = {
  [UserRole.DAILY_EMPLOYEE]: 'Diarista',
  [UserRole.MONTHLY_EMPLOYEE]: 'Mensalista',
  [UserRole.EMPLOYEE]: 'Registrado',
  [UserRole.NONE]: 'Indefinido',
  [UserRole.MANAGER_CREATOR]: 'Indefinido',
  [UserRole.MANAGER_VIEWER]: 'Indefinido',
  [UserRole.CLEANING_EMPLOYEE]: 'Limpeza',
};
